module.exports = __webpack_public_path__ + "media/images/icon/payment/union-pay-card-e0774b27cf324f36ffd4f8992589ea03.png";